import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { LookupUpdateComponent } from './modal/update/lookupupdate.component';
import { LookupService } from '../_services/lookup.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Lookup } from '../_model/Lookup';
import { LookupDeleteComponent } from './modal/delete/lookupdelete.component';
import {EventService} from '../_services/event.service';
import {UtilsService} from '../_services/utils.service';
import {HttpClient} from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-lookup',
    templateUrl: './lookup.component.html',
    styleUrls: ['./lookup.component.sass'],
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class LookupComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    displayedColumns: string[] = ['parentvalue', 'lookupCode', 'lookupValue', 'description', 'actions'];
    dataSource: MatTableDataSource<any>;
    lookupList: Lookup[];
    selectedLookup: Lookup;
    filterValue = null;
    paginatorIntl = new MatPaginatorIntl();

    constructor(private lookupService: LookupService,
                private toastr: ToastrService,
                public dialog: MatDialog,
                private eventService: EventService,
                private utilsService: UtilsService) { }

    ngOnInit() {
        const lookups = this.lookupService.localListLookups();
        lookups.forEach(element => {
            if (element.parentLookup != null) {
                element.parentvalue = element.parentLookup.lookupCode + ' '  + element.parentLookup.lookupValue;
            } else {
                element.parentvalue = '';
            }
        });
        this.dataSource = new MatTableDataSource(lookups);

        /**
         * TODO
         * angular material filter
         * filtreleme islemine mudahale etmek icin filterpredicate kullanilir
         * burada mudahale edip eldeki veriyi kucuk harflere cevirip includes metodu cagirarak
         * icinde geciyorsa filtrele demek istiyoruz
         */
        this.dataSource.filterPredicate =
            (data: Lookup, filter: string) => !filter || this.utilsService.toTurkishLowerCase(JSON.stringify(data)).includes(filter);

        this.paginatorIntl.itemsPerPageLabel = 'Satır sayısı';
        this.paginatorIntl.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
            return 'Kayıt bulunamadı' ;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
            return length + ' Kayıttan ' + (startIndex + 1) + ' - ' + endIndex + ' arası ' ;
        };
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.paginator._intl = this.paginatorIntl;
    }

    applyFilter(event: Event) {
        this.filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = this.utilsService.toTurkishLowerCase(this.filterValue.trim());
    }

    openUpdateModal(lookup: Lookup) {
        this.selectedLookup = lookup;

        const dialogRef = this.dialog.open(LookupUpdateComponent, {
            width: '550px',
            height: 'auto',
            data: lookup
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }

    openDeleteModal(lookup: Lookup) {
        this.selectedLookup = lookup;

        const dialogRef = this.dialog.open(LookupDeleteComponent, {
            width: '300px',
            data: lookup
        });

        dialogRef.afterClosed().subscribe(result => {
            localStorage.setItem('lookupList', JSON.stringify(result));
            this.ngOnInit();
        });
    }

    openLookupCreateModal() {
        const dialogRef = this.dialog.open(LookupUpdateComponent, {
            width: '550px',
            height: 'auto',
            minHeight: '550px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }

}
